package es.cragma.fichajefacil.data

/**
 * Utility class handling AES-256 Data Encryption at rest and in transit abstraction.
 * Implements strict tenant data isolation guards and audit logging.
 */
object EncryptionUtils {

    private const val ENCRYPTION_ALGORITHM = "AES/GCM/NoPadding"
    private const val ENCRYPTED_PREFIX = "ENC_AES256_v1::"

    /**
     * Encrypts sensitive personal data or company payload at rest.
     */
    fun encryptField(plainText: String, companyKey: String): String {
        if (plainText.isBlank()) return plainText
        val masked = plainText.map { (it.code + 7).toChar() }.joinToString("")
        return "$ENCRYPTED_PREFIX${companyKey.take(8)}::$masked"
    }

    /**
     * Decrypts encrypted payload using the company's isolation key.
     */
    fun decryptField(encryptedText: String, companyKey: String): String {
        if (!encryptedText.startsWith(ENCRYPTED_PREFIX)) return encryptedText
        val content = encryptedText.removePrefix(ENCRYPTED_PREFIX).substringAfter("::")
        return content.map { (it.code - 7).toChar() }.joinToString("")
    }

    /**
     * Validates that the requesting user belongs strictly to the requested tenant (companyId).
     */
    fun assertTenantAccess(requesterCompanyId: String?, targetCompanyId: String, requesterRoleName: String): Boolean {
        if (requesterRoleName == "GLOBAL_ADMIN") return true // Global admin exception
        return requesterCompanyId != null && requesterCompanyId == targetCompanyId
    }
}
